import React, { memo, useMemo } from 'react';
import { Accordion, Table } from 'onefaceui-react-components';
import PropTypes from 'prop-types';

import { getResourceTo } from 'react/utils/chatUtils';

function DistancesSection({ route }) {
  const formattedValues = useMemo(() => {
    if (!route.plannedDistance && !route.actualDistance) return null;

    const format = (value) => new Monet.Format.DISTANCE(value).toGrid().getValue();

    return {
      plannedDistance: format(route.plannedDistance),
      actualDistance: format(route.actualDistance)
    };
  }, [route]);

  if (!route.plannedDistance && !route.actualDistance) return null;

  return (
    <Accordion
      variant="transparent"
      size="sm"
      label={getResourceTo('DISTANCE')}
      dataTestId="distances-section"
    >
      <Table
        columns={[
          {
            title: getResourceTo('route.plannedDistance'),
            field: 'planned',
            resizable: false,
            headerSort: false,
            hozAlign: 'center'
          },
          {
            title: getResourceTo('route.actualDistance'),
            field: 'actual',
            resizable: false,
            headerSort: false,
            hozAlign: 'center'
          }
        ]}
        defaultData={[
          {
            planned: formattedValues.plannedDistance,
            actual: formattedValues.actualDistance
          }
        ]}
      />
    </Accordion>
  );
}

DistancesSection.propTypes = {
  route: PropTypes.object.isRequired
};

export default memo(DistancesSection);
